import { render, staticRenderFns } from "./CompareMultipleContracts.vue?vue&type=template&id=82c54698&scoped=true"
import script from "./CompareMultipleContracts.vue?vue&type=script&lang=js"
export * from "./CompareMultipleContracts.vue?vue&type=script&lang=js"
import style0 from "./CompareMultipleContracts.vue?vue&type=style&index=0&id=82c54698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c54698",
  null
  
)

export default component.exports